<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Gruppen</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-6 col-lg-12">
                    <stats-card title="Alle"
                                type="gradient-orange"
                                sub-title="6"
                                icon="fad fa-tasks"
                                class="mb-4 mb-xl-0">
                        <template v-slot:footer>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-6 col-lg-12">
                    <stats-card title="Untergruppen"
                                type="gradient-green"
                                sub-title="12"
                                icon="fad fa-badge-check"
                                class="mb-4 mb-xl-0">
                        <template v-slot:footer>
                        </template>
                    </stats-card>

                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">

                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Groups",
    data() {
        return {
            items: [
                {
                    title: "Call with Dave",
                    description: "10:30 AM",
                    done: true,
                    checkType: "success",
                },
                {
                    title: "Lunch meeting",
                    description: "10:30 AM",
                    done: false,
                    checkType: "warning",
                },
                {
                    title: "Argon Dashboard Launch",
                    description: "10:30 AM",
                    done: false,
                    checkType: "info",
                },
                {
                    title: "Winter Hackaton",
                    description: "10:30 AM",
                    done: true,
                    checkType: "danger",
                },
                {
                    title: "Dinner with Family",
                    description: "10:30 AM",
                    done: true,
                    checkType: "success",
                },
            ],
        };
    },
};
</script>
<style></style>
